'use client';

import Button from 'components/gruenland/atoms/button/Button';
import { Container } from 'components/gruenland/atoms/container/Container';
import { useFormat } from 'helpers/hooks/useFormat';
import { useState } from 'react';
import OrderLoader from './components/OrderLoader';
import OrderNotFound from './components/OrderNotFound';
import PublicOrderForm from './components/PublicOrderForm';
import PublicOrderPage from './components/PublicOrderPage';
import usePublicOrder from './hooks/usePublicOrder';
import { ShipmentState } from 'types/entity/order';

type Props = {
  search: {
    email?: string;
    order?: string;
  };
};

const PublicOrder: React.FC<Props> = ({ search }) => {
  const { order, shippingMethods, loading, loaded } = usePublicOrder(search);
  const { formatMessage } = useFormat({ name: 'gruenland' });
  const [showSearchForm, setShowSearchForm] = useState(false);
  const hasParams = !!(search.email && search.order);

  // If order is loaded, show it with a button to search for another order
  if (order) {
    return (
      <Container>
        <PublicOrderPage order={order} shippingMethods={shippingMethods.data ?? []} />

        {/* Return button - only show if order is complete and shipped */}
        {order.orderState === 'Complete' && order.shipmentState === ShipmentState.SHIPPED && (
          <div className="flex justify-end pt-4">
            <a
              href={'/returns?email=' + search.email + '&order=' + search.order}
              className="inline-block rounded-sm bg-primary-black px-4 py-2 text-[14px] font-medium text-white transition-colors hover:bg-secondary-black"
            >
              {formatMessage({ id: 'order.startReturn', defaultMessage: 'Effettua un reso' })}
            </a>
          </div>
        )}

        {!showSearchForm && (
          <div className="mt-8">
            <Button onClick={() => setShowSearchForm(true)}>
              {formatMessage({ id: 'publicorder.searchAnother', defaultMessage: 'Cerca un altro ordine' })}
            </Button>
          </div>
        )}
        {showSearchForm && <PublicOrderForm />}
      </Container>
    );
  }

  return (
    <Container>
      {hasParams ? (
        <>
          {loading && <OrderLoader />}
          {!loading && loaded && !order && <OrderNotFound />}
          {!loading && loaded && !order && <PublicOrderForm email={search.email} order={search.order} />}
        </>
      ) : (
        <PublicOrderForm email={search.email} order={search.order} />
      )}
    </Container>
  );
};

export default PublicOrder;
